import { render, staticRenderFns } from "./DataSelect.vue?vue&type=template&id=6c171d80&"
import script from "./DataSelect.vue?vue&type=script&lang=js&"
export * from "./DataSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports